import { useLayoutEffect, type ReactNode } from 'react'
import { canonicalPageUrl } from '../api/canonicalHost'

/**
 * Wraps every top-level route (`router.tsx`) and, on a host the page does not belong on, replaces it with
 * the same page on the right one before it draws, asks the server for anything or starts a sign-in
 * (LP-D5, #769; `api/canonicalHost.ts` has the why and the rules): an app page on the root domain or the
 * retired host goes to `app.`, a sign-in or invite page on `app.` or the retired host to the root domain.
 * Anywhere else, a local stack among them, it renders its children.
 *
 * `replace`, not `assign`: Back must not return to the wrong host, which would send the person on again.
 */
export function OnCanonicalHost({ children }: { children: ReactNode }) {
  const to = canonicalPageUrl(window.location)
  useLayoutEffect(() => {
    if (to) window.location.replace(to)
  }, [to])
  return to ? null : children
}
